import React from 'react';

import { FieldInput } from '../FieldInput/FieldInput';

const FieldInputHeadlined = ({ headline, hint = null, ...props }) => (
  <FieldInput {...props} hint={{ label: hint, value: headline }} />
);

export { FieldInputHeadlined };
